import React from 'react';
import { RiDeleteBinLine } from 'react-icons/ri';

import { useDeleteParticipantMutation } from '../../services/RttBridgeApi';

interface DeleteParticipantProps {
    // Add any props that your component will need 
    conferenceId: string | undefined;
    participantId: string;
}

const DeleteParticipant: React.FC<DeleteParticipantProps> = (props) => {
    const [deleteParticipant] = useDeleteParticipantMutation()

    // Declare a function for making the API request to delete a participant with the given ID
    const handelDeleteParticipant = () => {
        const info = { cId: props.conferenceId, pId: props.participantId }

        deleteParticipant({ info })
            .unwrap()
            .then((payload) => console.log('fulfilled', payload))
            .catch((error) => console.error('rejected', error));

    };


    return (
        <>
            <button onClick={handelDeleteParticipant} className='delete-part-button'>
                <RiDeleteBinLine className='icon' />
            </button>
        </>
    );
};

export default DeleteParticipant;